module.exports = __webpack_public_path__ + "img/luntanA_18.206b89ae.jpg";